import { render } from "./AddNewTopic.vue?vue&type=template&id=7436d676"
import script from "./AddNewTopic.vue?vue&type=script&lang=js"
export * from "./AddNewTopic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QSelect,QInput});qInstall(script, 'directives', {ClosePopup,Ripple});
